import { createTooltipTheme } from './createTooltipTheme';

export const DarkTheme = createTooltipTheme({
  name: 'dark-theme',
  fontColor: '#fff',
  backgroundColor: 'rgba(0, 0, 0, 0.85)',
  borderColor: 'rgba(0, 0, 0, 0)',
  boxShadow: 'none',
  opacity: 0.9,
});
